module.exports = __webpack_public_path__ + "48269353024877f33ca9014138999fbb.pdf";